// extracted by mini-css-extract-plugin
module.exports = {"root":"enhancePrecisionButton_root__3AMjm","statusCircle":"enhancePrecisionButton_statusCircle__3sFEf","label":"enhancePrecisionButton_label__2ehMB"};